var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "story-maker-sticker story-maker-sticker-survey",
      class: { edit: _vm.isSelected },
      on: { click: _vm.finish },
    },
    [
      _c("img", {
        staticClass: "img-change-color",
        attrs: { src: require("@/assets/img/instagram/ehf.png") },
        on: { click: _vm.stickerInstance.nextColor },
      }),
      _c("div", { staticClass: "sticker sticker-survey" }, [
        _vm.isSelected || _vm.stickerInstance.data.question
          ? _c(
              "div",
              {
                staticClass: "survey-header",
                style: {
                  backgroundColor: _vm.stickerInstance.data.color,
                },
              },
              [
                _c("textarea", {
                  ref: "textarea_question",
                  attrs: {
                    modelPath: "question",
                    cols: "20",
                    rows: "2",
                    wrap: "hard",
                    maxlength: "100",
                    placeholder: _vm.$t(
                      "dash.post-creator.story.survey-question"
                    ),
                    readonly: !_vm.isSelected,
                  },
                  domProps: { value: _vm.stickerInstance.data.question },
                  on: { input: _vm.resize },
                }),
              ]
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "choises" },
          _vm._l(Array.from({ length: 4 }), function (_, index) {
            return (_vm.isSelected ||
              _vm.stickerInstance.data.responses[index]) &&
              (index < 3 ||
                _vm.stickerInstance.data.responses[2] ||
                _vm.stickerInstance.data.responses[3])
              ? _c(
                  "div",
                  {
                    staticClass: "choise",
                    class: {
                      optional:
                        index >= 2 &&
                        !_vm.stickerInstance.data.responses[index],
                    },
                  },
                  [
                    _vm.isSelected
                      ? _c("textarea", {
                          ref: "textarea_choice",
                          refInFor: true,
                          attrs: {
                            cols: "20",
                            rows: "2",
                            wrap: "hard",
                            maxlength: "100",
                            placeholder: [
                              _vm.$t("dash.post-creator.story.survey-yes"),
                              _vm.$t("dash.post-creator.story.survey-no"),
                              _vm.$t(
                                "dash.post-creator.story.survey-add-option"
                              ),
                              _vm.$t(
                                "dash.post-creator.story.survey-add-option"
                              ),
                            ][index],
                            modelPath: `responses.${index}`,
                          },
                          domProps: {
                            value: _vm.stickerInstance.data.responses[index]
                              ? _vm.stickerInstance.data.responses[index]
                              : "",
                          },
                          on: { input: _vm.resize },
                        })
                      : _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.stickerInstance.data.responses[index],
                              expression:
                                "stickerInstance.data.responses[index]",
                            },
                          ],
                          ref: "textarea_choice",
                          refInFor: true,
                          attrs: {
                            cols: "20",
                            rows: "2",
                            wrap: "hard",
                            maxlength: "100",
                            placeholder: [
                              _vm.$t("dash.post-creator.story.survey-yes"),
                              _vm.$t("dash.post-creator.story.survey-no"),
                              _vm.$t(
                                "dash.post-creator.story.survey-add-option"
                              ),
                              _vm.$t(
                                "dash.post-creator.story.survey-add-option"
                              ),
                            ][index],
                            readonly: true,
                            modelPath: `responses.${index}`,
                          },
                          domProps: {
                            value: _vm.stickerInstance.data.responses[index],
                          },
                          on: {
                            mousedown: function ($event) {
                              $event.preventDefault()
                            },
                            selectstart: function ($event) {
                              $event.preventDefault()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.stickerInstance.data.responses,
                                index,
                                $event.target.value
                              )
                            },
                          },
                        }),
                  ]
                )
              : _vm._e()
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }